export default class FormValuesCollection {

  constructor () {
    this.values = []
  }

  /**
   *
   * @param item {{key: string, value: *, fieldType: string}}
   */
  push (item) {
    this.values.push(item)
  }

  /**
   *
   * @param item {{key: string, value: *, fieldType: string}}
   */
  replace (item) {
    for (let i = 0; i < this.values.length; i++) {
      let _innerItem = this.values[i]

      if (_innerItem.key === item.key) {
        this.values[i] = item
      }
    }
  }

  /**
   *
   * @param key
   * @param value
   * @param fieldType
   */
  setValue (key, value, fieldType = null) {
    for (let i = 0; i < this.values.length; i++) {
      let _innerItem = this.values[i]

      if (_innerItem.key === key) {
        _innerItem.value = value

        if (fieldType) {
          _innerItem.type = fieldType
        }

        return
      }
    }

    this.push({
      key:   key,
      value: value,
      type:  fieldType
    })
  }

  /**
   *
   * @param key
   * @return {*}
   */
  getValueItem (key) {
    for (let i = 0; i < this.values.length; i++) {
      let _innerItem = this.values[i]

      if (_innerItem.key === key) {
        return _innerItem
      }
    }

    return null
  }

  /**
   *
   * @param key
   * @return {null}
   */
  getValue (key) {
    let value = this.getValueItem(key)

    return value ? value.value : null
  }

  /**
   * @return Object
   */
  getValues () {
    return this.values
  }

  /**
   * @return Object
   */
  getValuesTransformed () {
    let output = {}

    for (let i = 0; i < this.values.length; i++) {
      let _innerItem = this.values[i]

      output[_innerItem.key] = _innerItem.value
    }

    return output
  }

}
